import { useId } from 'react'
import classNames from 'classnames'

import { EMPTY_FUNCTION } from '../../../constants/common'
import { getQaSelector } from '../../../utils/common'
import {
  GRETA_AI_CHAT_SOURCES,
  GretaAIChatSource,
  QA_NAME_GRETA_AI_CHAT_SOURCE_PICKER,
} from '../GretaAIChat.constants'

import { GretaAIChatSourcePickerCard } from './GretaAIChatSourcePickerCard'

import * as styles from './GretaAIChatSourcePicker.module.css'

function GretaAIChatSourcePicker({
  canSwitch = false,
  isFinanceNew = false,
  source = GretaAIChatSource.Crm,
  onSelect = EMPTY_FUNCTION,
}) {
  const name = useId()

  const qaProps = getQaSelector({ value: QA_NAME_GRETA_AI_CHAT_SOURCE_PICKER })

  function handleChange(event) {
    onSelect(event.target.value)
  }

  return (
    <div
      {...qaProps}
      className={classNames(styles.picker, {
        [styles.withBadge]: isFinanceNew,
      })}
    >
      {GRETA_AI_CHAT_SOURCES.map(item => (
        <GretaAIChatSourcePickerCard
          disabled={!canSwitch}
          isFinanceNew={isFinanceNew}
          key={item}
          name={name}
          selectedSource={source}
          source={item}
          onChange={handleChange}
        />
      ))}
    </div>
  )
}

export default GretaAIChatSourcePicker
